import { render, staticRenderFns } from "./BusinessLicense.vue?vue&type=template&id=53c60af0&scoped=true"
import script from "./BusinessLicense.vue?vue&type=script&lang=js"
export * from "./BusinessLicense.vue?vue&type=script&lang=js"
import style0 from "./BusinessLicense.vue?vue&type=style&index=0&id=53c60af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c60af0",
  null
  
)

export default component.exports